import React, { useState } from 'react';
import './NewsCardRevampedStyle.css';
import ResponsiveImage from './ResponsiveImage';
import detikcomNewLogo from '../media/detikcom_new.svg';
import tribunnewsNewLogo from '../media/tribunnews_new.svg';
import liputan6NewLogo from '../media/liputan6_new.svg';
import kompasNewLogo from '../media/kompas_new.svg';
import cnnIndonesiaNewLogo from '../media/cnn_indonesia_new.svg';
import placeholderLogo from '../media/placeholder.svg';
import cnbcNewLogo from '../media/cnbc_new.svg';
import { FaBook, FaShare, FaQrcode, FaTimes, FaHandSparkles } from 'react-icons/fa';
import { QRCodeCanvas } from 'qrcode.react';

function NewsCardRevamped({ item, currentTime, onSelect, onAnalyze }) {
    const [showQRModal, setShowQRModal] = useState(false);
    const parsedDate = new Date(item.pubDate);
    // Format date and time
    const formattedTime = parsedDate.toLocaleTimeString('id-ID', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).replace(/\./g, ':');

    const formattedDate = parsedDate.toLocaleDateString('id-ID', {
        // weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    // Validate item data
    if (!item || !item.source) {
        return (
            <div className="news-card-revamped">
                <div className="news-card-content-revamped">
                    <h3>Error: Data berita tidak valid</h3>
                    <p className="time-tag">🕒 {formattedDate} {formattedTime}</p>
                    <p className="source-tag">🌐 Sumber tidak tersedia</p>
                </div>
            </div>
        );
    }

    // Get appropriate logo for the news source
    const getLogoUrl = (source) => {
        if (source.includes("detik")) {
            return detikcomNewLogo;
        } else if (source.includes("tribun")) {
            return tribunnewsNewLogo;
        } else if (source.includes("liputan6")) {
            return liputan6NewLogo;
        } else if (source.includes("kompas")) {
            return kompasNewLogo;
        } else if (source.includes("cnn")) {
            return cnnIndonesiaNewLogo;
        } else if (source.includes("cnbc")) {
            return cnbcNewLogo;
        }
        return placeholderLogo;
    };

    // Get source name for display
    const getSourceName = (source) => {
        if (source.includes("detik")) {
            return "detikcom";
        } else if (source.includes("tribun")) {
            return "tribunnews";
        } else if (source.includes("liputan6")) {
            return "liputan6";
        } else if (source.includes("kompas")) {
            return "kompas";
        } else if (source.includes("cnn")) {
            return "cnnIndonesia";
        } else if (source.includes("cnbc")) {
            return "cnbcIndonesia";
        }
        return source;
    };

    // Handle share function
    const handleShare = () => {
        const stripHtml = (html) => {
            if (!html) return "";
            return html.replace(/<[^>]*>/g, "");
        };

        const shareContent = {
            title: stripHtml(item.title), // "Breaking News Today"
            text: `${stripHtml(item.description)}\n\nDibagikan melalui: Selidik | ${decodeURIComponent(window.location.href)} | Diperoleh: ${formattedDate} ${formattedTime}`,
            url: item.link || window.location.href, // "https://example.com/news"
        };

        if (navigator.share) {
            navigator.share(shareContent)
                .then(() => console.log("Shared successfully"))
                .catch((error) => console.error("Error sharing:", error));
        } else {
            // Fallback for browsers that don't support Web Share API
            alert('Share URL: ' + (item.link || window.location.href));
        }
    };

    // Function to decode HTML entities and remove HTML tags
    const decodeHtml = (html) => {
        if (!html) return "";

        // Create a temporary element
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Replace common HTML entities
        let text = doc.body.textContent || "";

        // Manual replacements for common entities
        const replacements = {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#039;': "'",
            '&nbsp;': ' '
        };

        Object.entries(replacements).forEach(([entity, replacement]) => {
            text = text.replace(new RegExp(entity, 'g'), replacement);
        });

        return text;
    };

    const sourceName = getSourceName(item.source);
    const shortTime = formattedTime.substring(0, 5); // Get only HH:MM format

    // Clean title and description
    const cleanTitle = decodeHtml(item.title);
    const cleanDescription = decodeHtml(item.description);

    return (
        <div className="news-card-revamped">
            <div className="card-header-new">
                <div className="provider-info">
                    {/* Logo beside provider name */}
                    <div className="provider-logo">
                        <img src={getLogoUrl(item.source)} alt="News Source Logo" loading="lazy" />
                    </div>
                    <div className="provider-details">
                        <span className="provider-name">{sourceName}</span>
                        <span className="date-separator"> · </span>
                        <span className="publish-date">{formattedDate} - {shortTime}</span>
                    </div>
                </div>
            </div>

            {/* Description now appears above the image and title */}
            <div className="news-description">
                {cleanDescription || "Tidak ada deskripsi tersedia."}
            </div>

            {/* Full-width news image with click handler */}
            <div className="news-image-full" onClick={onSelect}>
                <ResponsiveImage src={item.image} alt={cleanTitle} />
                {/* Title overlay at the bottom of the image */}
                <div className="news-title-overlay">
                    <h3 title={cleanTitle}>{cleanTitle}</h3> {/* Removed onClick */}
                </div>
            </div>

            <div className="source-reference">
                Dari {item.source}
            </div>

            <div className="action-buttons">
                <button className="action-btn" onClick={onSelect}>
                    <FaBook /> Baca
                </button>
                <button className="action-btn" onClick={handleShare}>
                    <FaShare /> Bagikan
                </button>
                <button className="action-btn" onClick={() => setShowQRModal(true)}>
                    <FaQrcode /> QR
                </button>
                <button className="action-btn" onClick={onAnalyze}>
                    <FaHandSparkles /> AI
                </button>
            </div>

            {/* QR Code Modal */}
            {showQRModal && (
                <div className="qr-modal-overlay">
                    <div className="qr-modal">
                        <div className="qr-modal-header">
                            <h4>Pindai QR Code</h4>
                            <button
                                className="close-btn"
                                onClick={() => setShowQRModal(false)}
                            >
                                <FaTimes />
                            </button>
                        </div>
                        <div className="qr-code-container">
                            <QRCodeCanvas
                                value={item.link || window.location.href}
                                size={200}
                                level={"M"}
                                includeMargin={true}
                            />
                        </div>
                        <p className="qr-description">
                            Pindai untuk membuka berita ini di perangkat lain
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default NewsCardRevamped;